import Logo from "./logo.png";
import LogoB from "./logoB.png";

const Images = {
  Logo,
  LogoB,
};

export default Images;
